import React from "react";
import PropTypes from "prop-types";
import TextStyles from "theme/components/text/TextStyles";

const H1 = ({ children }) => (
    <TextStyles
        as="h1"
        mb={["16px", null, null, null, null, "24px"]}
        textStyles={["Myriad Pro/40-120-semibold", null, null, null, null, "Myriad Pro/48-120-semibold"]}
    >
        {children}
    </TextStyles>
);

H1.propTypes = {
    children: PropTypes.node.isRequired,
};

export default H1;
